'use client';

import { useModalAdapterOptional } from '@module/helpers/modal/adapter';
import { useRef } from 'react';
import { useRegisterQueryErrorHandler } from './index';
type Props = {
  confirmText: string;
};
export function QueryErrorHandlerBridge({
  confirmText
}: Props) {
  const modalAdapter = useModalAdapterOptional();
  const adapterRef = useRef(modalAdapter);
  adapterRef.current = modalAdapter;
  useRegisterQueryErrorHandler((errorCode, error) => {
    switch (errorCode) {
      case 'loginMust':
        {
          adapterRef.current?.showConfirm({
            description: error.serverResponse.message,
            confirmText
          });
          break;
        }
    }
  });
  return null;
}